import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("slideShowImage2", component(opts));
  editor.BlockManager.add("slideShowImage2", block(opts));
};